import { useState, useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import api, { hardLogout } from '../lib/api';

function savedEmail() {
  try { return JSON.parse(localStorage.getItem('auth_user') || '{}').email || ''; } catch { return ''; }
}

// Finestra mostrata quando la sessione scade: il lavoro in corso resta nella pagina,
// basta reinserire la password e l'operazione interrotta viene ripetuta.
export default function SessionExpiredDialog() {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const pending = useRef(null);
  const email = savedEmail();

  useEffect(() => {
    window.__sessionDialogReady = true;
    const onExpired = (e) => {
      pending.current = e.detail;
      setPassword('');
      setError('');
      setOpen(true);
    };
    window.addEventListener('session-expired', onExpired);
    return () => {
      window.removeEventListener('session-expired', onExpired);
      window.__sessionDialogReady = false;
    };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setBusy(true);
    setError('');
    try {
      const res = await api.post('/auth/login', { email, password });
      localStorage.setItem('auth_token', res.data.token);
      localStorage.setItem('auth_user', JSON.stringify(res.data.user));
      setOpen(false);
      pending.current?.resolve();
    } catch (err) {
      setError(err.response?.data?.detail || 'Password non corretta');
    } finally {
      setBusy(false);
    }
  };

  const exit = () => {
    setOpen(false);
    pending.current?.reject();
    hardLogout();
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="max-w-sm" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} data-testid="session-expired-dialog">
        <form onSubmit={submit} className="space-y-4">
          <DialogHeader>
            <DialogTitle>Sessione scaduta</DialogTitle>
            <DialogDescription>
              Inserisci di nuovo la password per continuare. Quello che stavi facendo resta com'è e non viene perso.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-1.5">
            <Label>Utente</Label>
            <Input value={email} readOnly className="bg-slate-50" />
          </div>
          <div className="space-y-1.5">
            <Label>Password</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus autoComplete="current-password" data-testid="session-expired-password" />
            {error && <p className="text-xs text-red-600" data-testid="session-expired-error">{error}</p>}
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={exit}>Esci</Button>
            <Button type="submit" disabled={busy || !password} data-testid="session-expired-submit">{busy ? 'Accesso...' : 'Continua'}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
